import { defineMessages } from 'react-intl';

export default defineMessages({
    changePassword: {
        id: 'ri.changepassword.views.amp-users-profile.Change Password',
        defaultMessage: 'Change Password'
    },
    changeMessage: {
        id: 'ri.editprofile.views.amp-users-profile.Change the password for',
        defaultMessage: 'Change the password for'
    },    
    newPassword: {
        id: 'ri.changepassword.views.amp-users-profile.New Password',
        defaultMessage: 'New Password'
    },    
    currentPassword: {
        id: 'ri.changepassword.views.amp-users-profile.Current Password',
        defaultMessage: 'Current Password'
    },
    confirmPassword: {
        id: 'ri.changepassword.views.amp-users-profile.Confirm Password',
        defaultMessage: 'Confirm Password'
    },    
    buttonCancel: {
        id: 'ri.changepassword.views.amp-users-profile.Reset',
        defaultMessage: 'Reset'
    },    
    buttonChangePassword: {
        id: 'ri.changepassword.views.amp-users-profile.Change Password',
        defaultMessage: 'Change Password'
    },
    fieldEmpty: {
        id: 'ri.changepassword.views.amp-users-profile.Input field cannot be empty.',
        defaultMessage: 'Input field cannot be empty.'        
    },
    invalidAttempt: {
        id: 'ri.changepassword.views.amp-users-profile.Invalid attempt, retry the current password.',
        defaultMessage: 'Invalid attempt, retry the current password.'        
    },
    fieldIncorrect: {
        id: 'ri.changepassword.views.amp-users-profile.Confirm Password value does not match the New Password.',
        defaultMessage: 'Confirm Password value does not match the New Password.'        
    }, 
    invalidNewPassword: {
        id: 'ri.changepassword.views.amp-users-profile.The new Password value cannot be same as the Current Password.',
        defaultMessage: 'The new Password value cannot be same as the Current Password.'        
    },            
    invalidPasswordCriteria: {
        id: 'ri.changepassword.views.amp-users-profile.The new password value does not match the security criteria.',
        defaultMessage: 'The new password value does not match the security criteria.'        
    }            

});
